'use client'
import { vanillaApiClient } from '@/trpc/vanilla'
import { encrypt } from '@/utils'

export const fallbackUpdateUserContext = async ({
  previousUserContext,
  input,
  encryptKey,
}: {
  previousUserContext: string
  input: string
  encryptKey: string
}) => {
  try {
    const generatedUserContext =
      await vanillaApiClient.ai.generateUserContext.query({
        userContext: previousUserContext,
        userInput: input,
      })
    if (!generatedUserContext) return
    const encryptedUserContext = await encrypt(generatedUserContext, encryptKey)
    await vanillaApiClient.userSettings.update.mutate({
      generalInformation: encryptedUserContext,
    })
  } catch (error) {
    console.error(error)
  }
}
